package com.sweetlime.bingeamigo.presentation.features.search

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.bingeamigo.model.UserProfile
import com.sweetlime.bingeamigo.presentation.components.UserCard

@Composable
fun UserSearchContent(
    query: String,
    onQueryChange: (String) -> Unit,
    users: List<UserProfile>,
    isLoading: Boolean,
    followedUserIds: Set<String>,
    onFollow: (UserProfile) -> Unit,
    onUnfollow: (UserProfile) -> Unit,
    onOpenProfile: (String) -> Unit
) {

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xFF121212))
    ) {

        when {
            query.length < 3 -> UserSearchIdleState()
            isLoading -> Unit
            users.isEmpty() -> EmptyUserSearchState()
            else -> LazyColumn {
                items(users) { user ->
                    UserCard(
                        user = user,
                        isFollowing = user.id in followedUserIds,
                        onFollow = { onFollow(user) },
                        onUnfollow = { onUnfollow(user) },
                        onOpenProfile = { onOpenProfile(user.id) }
                    )
                }
            }
        }
    }
}

@Composable
private fun UserSearchIdleState() {
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(text = "👥", fontSize = 56.sp)
            Spacer(modifier = Modifier.height(16.dp))
            Text(text = "Find your friends", color = Color.White, style = MaterialTheme.typography.titleMedium)
            Spacer(modifier = Modifier.height(8.dp))
            Text(text = "Search by username", color = Color.Gray)
        }
    }
}

@Composable
private fun EmptyUserSearchState() {
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(text = "🔍", fontSize = 48.sp)
            Spacer(modifier = Modifier.height(12.dp))
            Text(text = "No users found", color = Color.White, style = MaterialTheme.typography.titleMedium)
            Spacer(modifier = Modifier.height(4.dp))
            Text(text = "Try another username", color = Color.Gray)
        }
    }
}